import { getOrganizedPermissions } from 'lane-shared/helpers/getOrganizedPermissions';
import { useFlag } from 'lane-shared/hooks';
import { FeatureFlag } from 'constants-flags';
import { useReservableManagementCalendarV2Enabled } from 'lane-shared/hooks/useReservableManagementCalendarV2Enabled';
import { PERMISSION_KEYS } from 'constants-permissions';
import {
  useSrChargeVerificationEnabled,
  useSrInvoiceBilledStatusEnabled,
  useTenantAdminCompanyRoleEnabled,
} from 'react-hooks';

export function useFilteredPermissions(hiddenPermissionDetails: string[] = []) {
  const pinManagementPermissions = useFlag(
    FeatureFlag.HardwarePinManagement,
    false
  );
  const isReservableManagementCalendarV2Enabled =
    useReservableManagementCalendarV2Enabled();
  const isSrChargeVerificationEnabled = useSrChargeVerificationEnabled();
  const isSrInvoiceBilledStatusEnabled = useSrInvoiceBilledStatusEnabled();
  const isTenantAdminCompanyRoleEnabled = useTenantAdminCompanyRoleEnabled();

  if (!pinManagementPermissions) {
    hiddenPermissionDetails.push(
      PERMISSION_KEYS.PERMISSION_PIN_MANAGEMENT_VIEW
    );
    hiddenPermissionDetails.push(
      PERMISSION_KEYS.PERMISSION_PIN_MANAGEMENT_CREATE_EDIT_DELETE
    );
  }

  if (!isReservableManagementCalendarV2Enabled) {
    hiddenPermissionDetails.push(
      PERMISSION_KEYS.PERMISSION_RESERVATIONS_MODULE_ACCESS
    );
  }

  if (!isSrChargeVerificationEnabled) {
    hiddenPermissionDetails.push(
      PERMISSION_KEYS.PERMISSION_WORK_ORDERS_CHARGE_VERIFICATION_MANAGE
    );
  }

  if (!isSrInvoiceBilledStatusEnabled) {
    hiddenPermissionDetails.push(
      PERMISSION_KEYS.PERMISSION_BILLING_PAYMENTS_INVOICE_MARK_BILLED
    );
  }

  if (!isTenantAdminCompanyRoleEnabled) {
    hiddenPermissionDetails.push(
      PERMISSION_KEYS.PERMISSION_WORK_ORDERS_SERVICE_REQUEST_VIEW_EDIT_COMPANY
    );
  }

  const startsWithKeywords = (permission: string, keywords: string[]) =>
    keywords.some(keyword => permission.startsWith(keyword));

  let permissionCategories = getOrganizedPermissions();

  permissionCategories = permissionCategories.map(
    (permission: { key: string; value: any }) => ({
      ...permission,
      value: permission.value.filter(
        (detail: { key: string }) =>
          !startsWithKeywords(detail.key, hiddenPermissionDetails)
      ),
    })
  );

  return permissionCategories.filter(category => category.value.length);
}
